import React, { Component } from 'react';
import cx from 'classnames';
import ErrorMessage from './ErrorMessage';
import { pad } from '../../../helpers/text';
import { MONTH_NAMES, DATE_INPUT_NAMES } from '../../../constants/Dates';

import './FieldBirthdate.scss';

const MAX_DAYS = 31;
const MAX_YEARS = 115;
const MIN_YEARS = 16;

const CURRENT_YEAR = new Date().getFullYear();

const DAY_VALUES = Array.from(Array(MAX_DAYS).keys()).map((value) => ({
	value: value + 1,
	name: value + 1,
}));
const MONTH_VALUES = MONTH_NAMES.map((name, value) => ({ value: value + 1, name }));
const YEAR_VALUES = Array.from(Array(MAX_YEARS - MIN_YEARS).keys()).map((year) => {
	let current = CURRENT_YEAR - MIN_YEARS - year;
	return { value: current, name: current };
});

const SelectRange = ({ name, values, value, error, testId, onChange, id, autoFocus }) => (
	<div className={cx('onboarding-field-date__column', `onboarding-field-date__column--${name}`)}>
		<label className="onboarding-field-date__hidden-label" htmlFor={id}>
			{DATE_INPUT_NAMES[name]}
		</label>
		<select
			autoFocus={autoFocus}
			className={cx('onboarding-field-date__field', { error })}
			value={value}
			onChange={onChange}
			data-test={testId ? `${testId}-${name}` : null}
			id={id}
		>
			<option key={-1} value="" disabled>
				{DATE_INPUT_NAMES[name]}
			</option>
			{values.map(({ value, name }) => (
				<option key={value} value={value}>
					{name}
				</option>
			))}
		</select>
	</div>
);

/**
 * Returns birthdate in ISO format "2018-01-01". Does not perform any
 * validation so it might return 2018-02-31.
 */
class FieldBirthdate extends Component {
	state = this.buildState(this.props.input.value);

	buildState(value) {
		if (value) {
			const [year, month, day] = value.split('-').map((part) => `${parseInt(part, 10)}`);
			return { year, month, day };
		}
		return {
			day: '',
			month: '',
			year: '',
		};
	}

	update(state) {
		this.setState(state);

		const { day, month, year } = { ...this.state, ...state };
		const { onChange, value } = this.props.input;

		if (day && month && year) {
			onChange(`${year}-${pad(month)}-${pad(day)}`);
		} else if (value) {
			onChange(null);
		}
	}

	render() {
		const { meta, testId } = this.props;
		const { day, month, year } = this.state;
		const showError = meta?.error && meta?.touched;

		return (
			<div className={cx('onboarding-field-date')}>
				<div className="onboarding-field-date__container">
					<SelectRange
						autoFocus
						name="day"
						onChange={(e) => this.update({ day: e.target.value })}
						values={DAY_VALUES}
						value={day}
						error={showError}
						testId={testId}
						id="day"
					/>
					<SelectRange
						name="month"
						onChange={(e) => this.update({ month: e.target.value })}
						values={MONTH_VALUES}
						value={month}
						error={showError}
						testId={testId}
						id="month"
					/>
					<SelectRange
						name="year"
						onChange={(e) => this.update({ year: e.target.value })}
						values={YEAR_VALUES}
						value={year}
						error={showError}
						testId={testId}
						id="year"
					/>
				</div>

				{showError && (
					<ErrorMessage error={meta.error} testId={testId ? `${testId}-error` : null} />
				)}
			</div>
		);
	}
}

export default FieldBirthdate;
